<template>
  <div style="background-color: #fafafa; padding: 20px;position: relative" v-loading="loading">
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }"
        >数据中心
        </el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/CoreAdmin' }"
        >全局管理设置
        </el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>

    <div style="font-size: 25px; margin-top: 15px">
      <p>全局管理设置</p>
    </div>

    <el-tabs v-model="activeName" type="border-card" :before-leave="changeTabs">
      <el-tab-pane class="zl" label="资料管理" name="1">
        <div>
        </div>
        <div>
          <div style="padding: 10px">
            <el-form>
              <el-row style="margin-left: 10px">
                <el-col :span="5">
                  <el-form-item :label="jc+'LOGO'" :required=ZLisSet>
                    <img :src="LOGO" height="130px" width="130px"
                         @click="dialogVisible = !dialogVisible"
                         style="margin-left: 20px;object-fit: cover;border-radius: 4px;cursor: pointer"
                         :onerror="'javascript:this.src=\''+ errorImg + '\''"/>
                    <el-dialog :visible.sync="dialogVisible" width="600px">
                      <img width="100%" :src="LOGO" alt="LOGO" :onerror="'javascript:this.src=\''+ errorImg + '\''">
                    </el-dialog>
                  </el-form-item>
                </el-col>
                <el-col :span="17">
                  <el-form-item v-if=ZLisSet style="display: inline-block">
                    <el-upload class="avatar-uploader showUploader"
                               action
                               :auto-upload="false"
                               :show-file-list="false"
                               :on-change="uploadSectionFile"
                    >
                      <el-button style="width: 130px;height: 130px" :loading="loading">
                        <i class="el-icon-plus avatar-uploader-icon" style="font-size: 50px;"></i>
                      </el-button>
                    </el-upload>
                  </el-form-item>
                  <div v-if=ZLisSet
                       style="width:170px;height:150px;display: inline-block;margin-left: 20px;color: #909399;">
                    支持常见图片格式，推荐上传分辨率大于400x200的透明通道PNG图片
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item :label="jc + '公司名称'" :required=ZLisSet>
                    <div style="text-align: left">
                      <el-input
                        v-if=ZLisSet
                        v-model="dataManagement.companyName"
                        type="text"
                        placeholder="请输入内容"
                        style="width: 70%"
                        maxlength="30"
                        show-word-limit
                      ></el-input>
                      <div v-else>
                        <el-input
                          v-model="dataManagement.companyName"
                          style="width: 70%; border-color: white"
                          :disabled=!ZLisSet
                        ></el-input>
                        <!--                        {{ dataManagement.companyName }}-->
                      </div>
                    </div>
                  </el-form-item>
                  <div class="grid-content bg-purple"></div>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label=" '\xa0\xa0' + '公司简称'">
                    <div style="text-align: left">
                      <el-input
                        :disabled=!ZLisSet
                        v-model="dataManagement.companyShortName"
                        type="text"
                        placeholder="请输入内容"
                        style="width: 70%"
                        maxlength="7"
                        show-word-limit
                      ></el-input>
                      <!--                      <span v-else>{{ dataManagement.companyShortName }}</span>-->
                    </div>
                  </el-form-item>
                  <div class="grid-content bg-purple-light"></div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item :label="jc+'公司简介'" :required=ZLisSet>
                    <el-input
                      :disabled=!ZLisSet
                      style="width: 70%"
                      v-model="dataManagement.companyInfo"
                      type="textarea"
                      :rows="5"
                      maxlength="140"
                      show-word-limit
                      placeholder="请输入内容"
                    >
                    </el-input>
                    <!--                      <span v-else style="width: 70%;display: inline-flex;line-height: 30px">{{ dataManagement.companyInfo }}</span>-->
                    <el-alert
                      description="公司简介等公司信息将会显示在供应商信息页面"
                      type="info"
                      :closable="false"
                      style="margin-left: 80px"
                    >
                    </el-alert>
                  </el-form-item>
                  <div class="grid-content bg-purple"></div>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="jc+'公司地址'" :required=ZLisSet>
                    <div style="text-align: left">
                      <el-input
                        :disabled=!ZLisSet
                        style="width: 70%"
                        v-model="dataManagement.companyAddress"
                        type="textarea"
                        :rows="3"
                        maxlength="30"
                        show-word-limit
                        placeholder="请输入内容"
                      ></el-input>
                      <!--                      <span v-else>{{ dataManagement.companyAddress }}</span>-->
                    </div>
                  </el-form-item>
                  <div class="grid-content bg-purple-light"></div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item :label="jc+'主要业务\n覆盖省份'" :required=ZLisSet>
                    <div class="block">
                      <el-select popper-class="el-select" v-model="dataManagement.coverageArea" v-if=ZLisSet
                                 clearable multiple placeholder="请选择供应商" style="width: 428px" value-key="value"
                                 @change="changeCoverageArea">
                        <el-option
                          v-for="item in dataManagement.allRegion"
                          :disabled="disableProvinces && dataManagement.coverageArea.length != 0"
                          :key="item.value"
                          :label="item.label"
                          :value='item.value'>
                        </el-option>
                      </el-select>

                      <span v-else-if="dataManagement.coverageArea.length == 31">
                          <el-tag type="info" style="color: #606266">全国</el-tag>
                      </span>
                      <span v-else
                            v-for="item in dataManagement.allRegion.filter(regionItem => dataManagement.coverageArea.indexOf(regionItem.value) != -1)">
                        <el-tag type="info" style="color: #606266;border-color: #606266">{{ item.label }}</el-tag>
                      </span>
                    </div>

                    <el-alert
                      description="处于业务覆盖省份的导购将会被优先推荐加入"
                      type="info"
                      :closable="false"
                      style="margin-left: 80px"
                    >
                    </el-alert>
                    <div class="grid-content bg-purple"></div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane
        class="yy"
        label="运营规则配置"
        name="2"
        style="width: 100%"
      >
        <el-form label-width="90px" style="padding: 10px">

          <div class="title-line">
            <div style="width: 5px;background: #ED7043;"></div>
            <div class="title">申报审核规则</div>
          </div>

          <el-form-item
            :label="'销量申报\n预警线'"
            :required=YYisSet>

            <el-button
              style="
                  cursor: text;
                  background-color: #f5f7fa;
                  border-color: #dcdfe6;
                  border-width: 1px 0px 1px 1px;
                  border-radius: 4px 0px 0px 4px;
                  color: #606266;">每日预警线
            </el-button>
            <div class="ov-inline">
              <el-select
                v-model="Limit.dayLimit"
                :disabled=!YYisSet
                @change="changeLimit"
                style="width: 120px;border-radius: 0px;">
                <el-option v-for="item in warningLine" :disabled="item.value == '按金额'" :key="item.value"
                           :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-input
                placeholder="请输入数量"
                :disabled='!YYisSet || Limit.dayLimit == "不限制"'
                v-model="ruleConfiguration.dayLimit"
                style="width: 390px"
                prefix-icon="el-icon-close"
                :min="0"
                @blur="defaultData()"
                oninput="value=value.replace(/[^\d]/g,'')"/>
            </div>
            <el-alert
              description="若某天导购申报的产品销售数量总和超过每日预警线，将会自动转到业务员端进行审批。"
              type="info"
              :closable="false"
            />

            <div style="margin: 20px 0"></div>

            <el-button
              style="
                  cursor: text;
                  background-color: #f5f7fa;
                  border-color: #dcdfe6;
                  border-width: 1px 0px 1px 1px;
                  border-radius: 4px 0px 0px 4px;
                  color: #606266;">每单预警线
            </el-button>
            <div class="ov-inline">
              <el-select
                v-model="Limit.ticketLimit"
                :disabled=!YYisSet
                @change="changeLimit"
                style="width: 120px;border-radius: 0px;">
                <el-option v-for="item in warningLine" :disabled="item.value == '按金额'" :key="item.value"
                           :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-input
                placeholder="请输入数量"
                :disabled='!YYisSet || Limit.ticketLimit == "不限制"'
                v-model="ruleConfiguration.ticketLimit"
                style="width: 390px"
                prefix-icon="el-icon-close"
                :min="0"
                @blur="defaultData($event)"
                oninput="value=value.replace(/[^\d]/g,'')"/>
            </div>
            <el-alert
              description="若导购申报的单张小票中，销售数量总和超过每单预警线，将会自动转到业务员端进行审批。"
              type="info"
              :closable="false"
            />

            <div style="margin: 20px 0"></div>

            <el-button
              style="
                  cursor: text;
                  background-color: #f5f7fa;
                  border-color: #dcdfe6;
                  border-width: 1px 0px 1px 1px;
                  border-radius: 4px 0px 0px 4px;
                  color: #606266;">每品预警线
            </el-button>

            <div class="ov-inline">
              <el-select
                v-model="Limit.productLimit"
                :disabled=!YYisSet
                @change="changeLimit"
                style="width: 120px;border-radius: 0px;border-right: 0px">
                <el-option v-for="item in warningLine" :disabled="item.value == '按金额'" :key="item.value"
                           :label="item.label" :value="item.value"></el-option>
              </el-select>

              <el-input
                placeholder="请输入数量"
                :disabled="!YYisSet || Limit.productLimit=='不限制'"
                style="width: 390px;"
                v-model="ruleConfiguration.productLimit"
                prefix-icon="el-icon-close"
                :min="0"
                @blur="defaultData($event)"
                oninput="value=value.replace(/[^\d]/g,'')"/>

              <el-button :loading="loading1" style="background-color: #ff6633;color: white;margin-left: 10px"
                         @click="reportExcel" :disabled="!YYisSet">导出单品预警系数模板
              </el-button>

              <el-button :loading="loading2" style="background-color: #ff6633;color: white"
                         @click="putExcel" :disabled="!YYisSet">上传单品预警系数表
              </el-button>

              <input type="file" ref="uploadLabel" v-show="false" accept=".xls,.xlsx" @change="extraExcel"/>
            </div>
            <el-alert
              description="若导购申报的单张小票中，某项产品的销售数量超出（每品预警线*该产品的单品预警系数），将会自动转到业务员端进行审批。"
              type="info"
              :closable="false"/>
          </el-form-item>

          <el-form-item :label="'审单\n规则提示'">
            <el-input
              :disabled=!YYisSet
              style="width: 60%"
              type="textarea"
              :rows="3"
              maxlength="80"
              show-word-limit
              placeholder="未输入"
              v-model="ruleConfiguration.approvalTips"
            >
            </el-input>
            <el-alert
              description="可将审核规则提示给审单人员"
              type="info"
              :closable="false"
            >
            </el-alert>
          </el-form-item>

          <div class="title-line">
            <div style="width: 5px;background: #ED7043;"></div>
            <div class="title">提成资金结算</div>
          </div>

          <el-form-item :label="'小票申报\n失效期限'" :required=YYisSet>
            <el-input-number
              :min="0"
              v-model="ruleConfiguration.ticketEffective"
              :disabled=!YYisSet
              :controls=YYisSet
            >
            </el-input-number>
            <el-alert
              description="若设置为7，则1号交易的小票需在7号23:59前完成申报"
              type="info"
              :closable="false"/>
          </el-form-item>

          <el-form-item :label="'红利补发\n追溯期限'" :required=YYisSet>
            <div style="text-align: left">
              <el-input-number
                :min="0"
                v-model="ruleConfiguration.settleEffective"
                :disabled=!YYisSet
                :controls=YYisSet
              ></el-input-number>
            </div>
            <el-alert
              description="导购存在待发红利时，系统的最长补发期限"
              type="info"
              :closable="false"
            >
            </el-alert>
          </el-form-item>

          <el-form-item :label="'审核结\n算时效'" :required=true>
            <el-select
              :disabled=true
              v-model="ruleConfiguration.auditType"
              value-key="id"
              placeholder="当天审核,隔天审核结算"
              style="width: 60%"
            >
              <el-option
                v-for="item in auditType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-alert
              style="width:60%"
              description="若设为当天申报当天结算则每日预警线及进销存预警将失效；导购当天下午三点前申报视作当天申报； 若申报小票触发预警机制，则结算时效将依据业务员审核耗时向后递延；"
              type="info"
              :closable="false"
            >
            </el-alert>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane
        class="cw"
        label="财务规则配置"
        name="3"
      >
        <div class="ov-inline" style="width: 50%; padding: 10px">
          <el-form label-width="90px">
            <el-form-item :label="'基础钱包\n充值方式'">
              <div style="text-align: left">
                <el-input placeholder="请输入内容" v-model="basicAccount.account" :disabled=true>
                  <template slot="prepend" :disabled=true>{{ basicAccount.name }}</template>
                </el-input>
                <el-input
                  placeholder="XXXXX-XXXXX-XXXXX"
                  v-model="basicAccount.accountNum"
                  :disabled=true
                >
                  <el-button
                    slot="append"
                    icon="el-icon-copy-document"
                    @click="handlePaste1"
                  ></el-button>
                </el-input>
                <el-alert
                  description="如需修改钱包账户请联系平台协助"
                  type="info"
                  :closable="false">
                </el-alert>
              </div>
            </el-form-item>

            <el-form-item :label="'服务费钱包\n充值方式'">
              <div style="text-align: left;cursor:text">
                <el-input placeholder="中国建设银行上海大连路支行" :disabled=true>
                  <template slot="prepend">上海橙籽维管信息技术有限公司</template>
                </el-input>
                <el-input
                  placeholder="31050175410000000956"
                  :disabled=true
                >
                  <el-button
                    slot="append"
                    icon="el-icon-copy-document"
                    @click="handlePaste2"
                  ></el-button>
                </el-input>
                <el-alert
                  description="如需修改钱包账户请联系平台协助"
                  type="info"
                  :closable="false">
                </el-alert>
              </div>
            </el-form-item>

            <el-form-item label="充值方式" :required=JHisSet>
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="fundsConfiguration.issueType"
                :disabled=!JHisSet
                class="selects"
                @change="changeIssueType"
              >
                <el-option
                  v-for="item in issueType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-alert
                description="服务费将以指定的支付方式进行支付"
                type="info"
                :closable="false">
              </el-alert>
            </el-form-item>

            <el-form-item :label="'打款账户\n户名'" :required=JHisSet>
              <el-select
                :disabled="fundsConfiguration.issueType == 1 || JHisSet == false"
                v-model="fundsConfiguration.personalAccount"
                multiple
                clearable
                filterable
                allow-create
                default-first-option
                placeholder="请输入用于打款的私人银行账户户名"
                style="width: 100%"
                value-key="name"
              >
                <el-option
                  v-for="item in personalAccount"
                  :label="item.name"
                  :key="item.name"
                  :value="item"
                ></el-option>
              </el-select>
              <el-alert
                description="只允许指定的打款账户进行私户打款操作"
                type="info"
                :closable="false"
              >
              </el-alert>
            </el-form-item>

            <el-form-item :label="'服务费\n支付方式'" :required=JHisSet>
              <el-select
                :disabled=!JHisSet
                style="width: 100%"
                v-model="fundsConfiguration.method"
                placeholder="银行单独转账/从基础钱包账户划扣"
              >
                <el-option
                  v-for="item in method"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-alert
                description="服务费将以指定的支付方式进行支付"
                type="info"
                :closable="false"
              >
              </el-alert>
            </el-form-item>

            <el-form-item label="开票信息" :required=true>
              <el-input
                v-model="fundsConfiguration.title"
                :disabled=true
                placeholder="开票公司名"
              ></el-input>
              <div style="height: 7px"></div>
              <el-input
                v-model="fundsConfiguration.creditCode"
                :disabled=true
                placeholder="纳税人识别号"
              ></el-input>
              <div style="height: 7px"></div>
              <el-input
                v-model="fundsConfiguration.address"
                :disabled=true
                placeholder="地址"
              ></el-input>
              <div style="height: 7px"></div>
              <el-input
                v-model="fundsConfiguration.tel"
                :disabled=true
                placeholder="手机号码"
              ></el-input>
              <div style="height: 7px"></div>
              <el-input
                v-model="fundsConfiguration.bank"
                :disabled=true
                placeholder="开户行名称"
              ></el-input>
              <div style="height: 7px"></div>
              <el-input
                v-model="fundsConfiguration.account"
                :disabled=true
                placeholder="银行卡号"
              ></el-input>
              <el-alert
                description="发票抬头将会以展示的开票信息开具，如需修改请联系平台协助"
                type="info"
                :closable="false"
              >
              </el-alert>
            </el-form-item>

            <el-form-item :label="'财务\n联系人'">
              <span v-if=JHisSet>
                <el-select
                  multiple
                  clearable
                  style="width: 500px"
                  placeholder="请选择要接受通知的通路管理助手账户"
                  v-model="fundsConfiguration.balanceNotification"
                  value-key="name"
                >
                  <el-option
                    v-for="item in balanceNotification"
                    :key="item"
                    :value="item"
                    :label="item.name"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right;padding-right:16px; color: #8492a6; font-size: 10px">{{
                        item.phoneNumber
                      }}</span
                    >
                  </el-option>
                </el-select>
              </span>
              <span v-else-if="fundsConfiguration.balanceNotification.length != 0"
                    v-for="item in fundsConfiguration.balanceNotification">
                  <el-tag type="info" style="color: #606266;border-color: #606266">{{
                      item.name + "   " + item.phoneNumber
                    }}</el-tag>&nbsp;
              </span>
              <span v-else>
                <el-tag type="info" style="color: #606266;border-color: #606266">不通知</el-tag>
              </span>
              <el-alert
                description="充值提醒、充值到账通知、账户余额不足通知等"
                type="info"
                :closable="false"
              >
              </el-alert>
            </el-form-item>
          </el-form>

        </div>
      </el-tab-pane>

      <el-tab-pane
        class="yw"
        label="业务流程复核"
        name="4"
        style="width: 100%"
      >
        <el-form label-width="110px" class="myForm1" style="padding: 10px" ref="ruleForm2" :rules="rules"
                 :model="processReview.limitAudit">
          <div class="title-line">
            <div style="width: 5px;background: #ED7043;"></div>
            <div class="title">业务复核流程设置</div>
          </div>

          <el-form-item :label="'导购签约审核'">
            <el-radio-group v-model="processReview.signMode" :disabled=!YWisSet>
              <el-radio :label="2">无需审核</el-radio>
              <el-radio :label="1">需业务员审核</el-radio>
            </el-radio-group>
            <el-alert
              description="如无需业务员审核，导购在申请签约后直接对接业务员，即可进行销量申报等操作；如需审核，则待业务员审核通过后才可申报。"
              type="info"
              :closable="false"
            >
            </el-alert>
          </el-form-item>
          <el-form-item :label="'超预警线销量申报审核'" :required=YYisSet prop="reAuditPerson">
            <div style="display: flex;">
              <span style="font-size: 13px;display: inline-block;margin-right: 10px"
                    :style="{'color':'#666666'}">业务员审核后</span>
              <el-radio-group v-model="processReview.limitAudit.reAudit" :disabled="!YWisSet" @change="judgementField1">
                <el-radio style="line-height: 40px" :label="0">直接通过</el-radio>
                <el-radio style="line-height: 40px" :label="1">需复核</el-radio>
              </el-radio-group>
              <span style="font-size: 13px;display: inline-block;margin-left: 10px"
                    :style="{'color':!YWisSet?'#C1C4CB':'#666666'}">复核人包括：</span>
              <el-select
                clearable
                :disabled="!(YWisSet && processReview.limitAudit.reAudit)"
                v-model="field1"
                style="width: 250px"
                multiple
                @change="judgementField1">
                <div style="height: 30px">
                  <el-checkbox style="float: left;margin: 5px;padding-left: 15px" @change="selectAllIdentity(1)"
                               v-model="selectAllOption1">
                    全选
                  </el-checkbox>
                </div>
                <el-option v-for="value in identityField1" :key="value" :label="value" :value="value">
                </el-option>
              </el-select>
            </div>
            <el-alert
              description="若设定为需复审，相关复审人通过后，导购所提交的销量申报将由平台进一步审核和结算"
              type="info"
              :closable="false"
            >
            </el-alert>
          </el-form-item>
        </el-form>

        <el-form class="myForm1" label-width="110px" style="padding: 10px" ref="ruleForm1" :rules="rules"
                 :model="processReview.packageAudit">
          <el-form-item :label="'导购提成规则变更审核'" :required=YYisSet prop="reAuditPerson">
            <div style="display: flex;">
              <span style="font-size: 13px;display: inline-block;margin-right: 10px"
                    :style="{'color':'#666666'}">业务员提交后</span>
              <el-radio-group v-model="processReview.packageAudit.reAudit" :disabled="!YWisSet"
                              @change="judgementField2">
                <el-radio style="line-height: 40px" :label="0">直接生效</el-radio>
                <el-radio style="line-height: 40px" :label="1">需复核</el-radio>
              </el-radio-group>
              <span style="font-size: 13px;display: inline-block;margin-left: 10px"
                    :style="{'color':!YWisSet?'#C1C4CB':'#666666'}">复核人包括：</span>
              <el-select
                clearable
                :disabled="!(YWisSet && processReview.packageAudit.reAudit)"
                v-model="field2"
                multiple
                style="width: 250px"
                @change="judgementField2">
                <div style="height: 30px">
                  <el-checkbox style="float: left;margin: 5px;padding-left: 15px" @change="selectAllIdentity(2)"
                               v-model="selectAllOption2">
                    全选
                  </el-checkbox>
                </div>
                <el-option v-for="value in identityField2" :key="value" :label="value" :value="value">
                </el-option>
              </el-select>
            </div>
            <el-alert
              description="若设定为需复审，相关复审人通过后，导购将按新的提成规则开通申报权限并结算"
              type="info"
              :closable="false"
            >
            </el-alert>
          </el-form-item>
        </el-form>

        <el-form class="myForm1" label-width="110px" style="padding: 10px" ref="processAuditForm" :rules="rules"
                 :model="processReview.processAudit">
          <el-form-item label="销量申报发起复核规则" :required=YYisSet prop="reAuditPerson">
            <div style="display: flex;">
              <span style="font-size: 13px;display: inline-block;margin-right: 10px"
                    :style="{'color':'#666666'}">业务员发起后</span>
              <el-radio-group v-model="processReview.processAudit.reAudit" :disabled="!YWisSet"
                              @change="changeAuditType(processReview.processAudit)">
                <el-radio style="line-height: 40px" :label="false">直接生效</el-radio>
                <el-radio style="line-height: 40px" :label="true">需复核</el-radio>
              </el-radio-group>

              <span style="font-size: 13px;display: inline-block;margin-left: 10px"
                    :style="{'color':!YWisSet?'#C1C4CB':'#666666'}">复核人包括：</span>

              <el-select
                clearable
                :disabled="!(YWisSet && processReview.processAudit.reAudit)"
                v-model="processReview.processAudit.reAuditPerson"
                multiple
                value-key="type"
                style="width: 250px">

                <select-all-option v-model="processReview.processAudit.reAuditPerson"
                                   :data="reAuditPersonList" dataValue="type"/>
                <el-option v-for="item in reAuditPersonList"
                           :key="item.type"
                           :label="item.label"
                           :value="item.type">
                </el-option>
              </el-select>
            </div>
            <el-alert
              description="若设定为需复审，相关复审人通过后，发送给平台进行复审"
              type="info"
              :closable="false"
            >
            </el-alert>
          </el-form-item>
        </el-form>

        <!-- 允许过期小票结算 -->
        <el-form class="myForm1" label-width="110px" style="padding: 10px" ref="ignoreTicketForm" :rules="rules"
                 :model="processReview.ignoreTicketAudit">
          <el-form-item label="允许过期小票结算规则" :required=YYisSet prop="reAuditPerson">
            <div style="display: flex;">
              <span style="font-size: 13px;display: inline-block;margin-right: 10px"
                    :style="{'color':'#666666'}">业务员发起后</span>
              <el-radio-group v-model="processReview.ignoreTicketAudit.reAudit" :disabled="!YWisSet"
                              @change="changeAuditType(processReview.ignoreTicketAudit)">
                <el-radio style="line-height: 40px" :label="false">直接生效</el-radio>
                <el-radio style="line-height: 40px" :label="true">需复核</el-radio>
              </el-radio-group>

              <span style="font-size: 13px;display: inline-block;margin-left: 10px"
                    :style="{'color':!YWisSet?'#C1C4CB':'#666666'}">复核人包括：</span>

              <el-select
                clearable
                :disabled="!(YWisSet && processReview.ignoreTicketAudit.reAudit)"
                v-model="processReview.ignoreTicketAudit.reAuditPerson"
                multiple
                value-key="type"
                style="width: 250px">

                <select-all-option v-model="processReview.ignoreTicketAudit.reAuditPerson"
                                   :data="reAuditPersonList" dataValue="type"/>
                <el-option v-for="item in reAuditPersonList"
                           :key="item.type"
                           :label="item.label"
                           :value="item.type">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>


        <el-form label-width="110px" style="padding: 10px" ref="ruleForm" :rules="rules" :model="processReview">
          <div class="title-line">
            <div style="width: 5px;background: #ED7043;"></div>
            <div class="title">管理员设置</div>
          </div>

          <el-form-item label="区域管理员" prop="regionManager">
              <span v-if="YWisSet">
                <el-select
                  multiple
                  clearable
                  style="width: 60%"
                  placeholder="请选择区域管理员"
                  v-model="processReview.regionManager"
                  value-key="name"
                >
                  <el-option
                    v-for="item in regionManager"
                    :key="item"
                    :value="item"
                    :label="item.name"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span
                      style="float: right; padding-right:16px;color: #8492a6; font-size: 10px">{{
                        item.phoneNumber
                      }}</span>
                  </el-option>
                </el-select>
              </span>
            <span v-else-if="processReview.regionManager.length != 0"
                  v-for="(item,index) in processReview.regionManager" :key="index">
                  <el-tag type="info"
                          style="color: #606266;border-color: #606266">{{
                      item.name + "  " + item.phoneNumber
                    }}</el-tag>&nbsp;
            </span>

            <span v-else>
                  <el-button @click="YWisSet = true">点此设置</el-button>
            </span>
          </el-form-item>
        </el-form>

        <el-form label-width="110px" style="padding: 10px" ref="ruleForm" :rules="rules" :model="processReview">
          <el-form-item :label="'总部管理员'" prop="wechatNotification">
              <span v-if=YWisSet>
                <el-select
                  multiple
                  clearable
                  style="width: 60%"
                  placeholder="请选择要接受通知的通路管理助手账户"
                  v-model="processReview.wechatNotification"
                  value-key="name"
                >
                  <el-option
                    v-for="item in wechatNotification"
                    :key="item"
                    :value="item"
                    :label="item.name"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span
                      style="float: right; padding-right:16px;color: #8492a6; font-size: 10px">{{
                        item.phoneNumber
                      }}</span>
                  </el-option>
                </el-select>
              </span>
            <span v-else-if="processReview.wechatNotification.length != 0"
                  v-for="(item,index) in processReview.wechatNotification" :key="index">
                  <el-tag type="info"
                          style="color: #606266;border-color: #606266">{{
                      item.name + "  " + item.phoneNumber
                    }}</el-tag>&nbsp;
            </span>
            <span v-else>
              <el-button @click="YWisSet = true">点此设置</el-button>
            </span>
            <el-alert
              style="width:60%"
              description="区域/总部管理员可作为复核人，复核业务所提交的流程（流程包括：超预警线销量申报审核、导购提成规则变更审核、通路活动审核），建议设置为区域/总部市场经理等角色"
              type="info"
              :closable="false"
            >
            </el-alert>
          </el-form-item>
        </el-form>

      </el-tab-pane>
    </el-tabs>
    <div style="position: absolute;right:30px;top:102px;">
      <div>
        <el-button v-if="ZLisSet || YYisSet || JHisSet || YWisSet" type="small"
                   style="color: white;border-color: #ff6633;background-color: #ff6633;"
                   :loading="loading"
                   @click="confirmChange">确认修改
        </el-button>
        <el-button v-if="ZLisSet || YYisSet || JHisSet || YWisSet" type="small"
                   style="color: #ff6633; border-color: #ff6633"
                   :loading="loading"
                   @click="cancelChange">取消修改
        </el-button>
        <el-button v-if="!ZLisSet && !YYisSet && !JHisSet && !YWisSet" style="background-color: #ff6633;color: white"
                   type="small"
                   @click="editInfo" :disabled="dashboardSales">点击修改
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  coreAdmin,
  putExcel,
  reportExcel,
  setDataManager,
  setFundsConfiguration,
  setProcessReview,
  setRuleConfiguration,
  uploadLogo
} from "@/api/CoreAdmin"
import errorImg1 from "@/assets/errorImg/f127cbec-14f4-4050-8dbc-2e1beda66761.jpg"


import {MessageBox} from "element-ui";
import selectAllOption from "@/components/selectAllOption";

export default {
  inject: ['reload'],
  components: {selectAllOption},
  data() {
    return {
      checked: true,
      field1: [], //选中的选项
      field2: [],
      identityField1: ['区域管理员', '总部管理员'],  //选项
      identityField2: ['区域管理员', '总部管理员'],
      reAuditPersonList: [],
      selectAllOption1: false,
      selectAllOption2: false,
      errorImg: errorImg1,
      dialogVisible: false,
      disableProvinces: false,
      jc: '\xa0\xa0',
      id: "",
      token: "",
      activeName: "1",
      ZLisSet: false,
      YYisSet: false,
      JHisSet: false,
      YWisSet: false,
      loading: true,
      loading1: false,
      loading2: false,
      //备份数据,还原
      data: {
        dataManagement: {},
        ruleConfiguration: {},
        fundsConfiguration: {},
        processReview: {}
      },
      photoInfo: {
        files: {},
        photo: '',
        photoObj: ''
      },
      LOGO: [],
      dataManagement: {
        supplierId: "",
        name: "",
        companyName: "公司名称",
        companyShortName: "公司简称",
        companyInfo: "公司简介",
        companyAddress: "公司地址",
        coverageArea: [],
        allRegion: []
      },
      ruleConfiguration: {
        supplierId: "",
        name: "",
        dayLimit: 0,
        ticketLimit: 0,
        productLimit: 0,
        settleEffective: "",
        ticketEffective: "",
        approvalTips: "审单规则提示",
        auditType: 1
      },
      Limit: {
        dayLimit: '按数量',
        ticketLimit: '按数量',
        productLimit: '按数量'
      },
      fundsConfiguration: {
        supplierId: "",
        name: "",
        accountAccountNum: "",
        issueType: "",
        personalAccount: [],
        method: "",
        title: "",
        creditCode: "",
        address: "",
        tel: "",
        bank: "",
        account: "",
        balanceNotification: [],
        companyName: '',
        companyShortName: '',
      },
      processReview: {
        signMode: "",
        packageAudit: {
          needManagerAudit: false,
          reAudit: 0,
          reAuditPerson: []
        },
        limitAudit: {
          needManagerAudit: false,
          reAudit: 0,
          reAuditPerson: []
        },
        //销量申报发起重审
        processAudit: {
          needManagerAudit: true,
          //是否需要复核
          reAudit: false,
          reAuditPerson: []
        },
        //过期小票结算
        ignoreTicketAudit: {
          needManagerAudit: true,
          reAudit: false,
          reAuditPerson: []
        },
        //区域管理员已选中
        regionManager: [],
        //总部管理员已选中
        wechatNotification: [],
        accountManagerCount: 0,
        businessManagerCount: 0
      },
      warningLine: [{value: '按数量', label: '按数量'}, {value: '按金额', label: '按金额'}, {
        value: "不限制",
        label: '不限制'
      }],
      signMode: [
        {
          value: 1,
          label: "由业务员审核",
        },
        {
          value: 2,
          label: "导购直接签约",
        },
      ],
      //区域管理员
      regionManager: [],
      //总部管理员
      wechatNotification: [],
      balanceNotification: [],
      personalAccount: [],
      issueType: [
        {
          value: "1",
          label: "对公转账"
        },
        {
          value: "2",
          label: "私户打款"
        }
      ],
      method: [
        {
          value: "1",
          label: "基础钱包划扣"
        },
        {
          value: "2",
          label: "银行单独转账"
        },
        {
          value: "3",
          label: "待客户确认/不扣除"
        }
      ],
      basicAccount: [],
      dashboardSales: false,
      auditType: [
        {
          label: '当天申报,隔天审核结算',
          value: '1'
        },
        {
          label: '当天申报,当天审核结算',
          value: '2'
        }
      ],
      rules: {
        regionManager: [
          {required: true, message: '请设置区域管理员', trigger: 'change'}
        ],
        wechatNotification: [
          {required: true, message: '请设置总部管理员', trigger: 'change'}
        ],
        reAuditPerson: [
          {message: '请设置区域/总部管理员', trigger: 'change'}
        ]
      }
    };
  },
  watch: {
    activeName(val) {
      this.queryDataByPage();

      if (val == 4) {
        this.reAuditPersonList = [
          {
            type: 1,
            label: '区域管理员'
          },
          {
            type: 2,
            label: '总部管理员'
          }
        ]
      }
    }
  },
  created() {
    this.activeName = localStorage.getItem('activteName') == null || localStorage.getItem('activteName') == 0 ? '1' : localStorage.getItem('activteName').toString()
    localStorage.removeItem('activteName')
    this.dashboardSales = localStorage.getItem('dashboardSales') == 2 ? true : false
    this.token = localStorage.getItem("token");
    this.id = localStorage.getItem("supplierId");
    this.queryDataByPage();
  },
  computed: {},
  mounted() {
    this.dataManagement.name = localStorage.getItem("supplierId");
    this.ruleConfiguration.name = localStorage.getItem("supplierId");
    this.fundsConfiguration.name = localStorage.getItem("supplierId");
  },
  methods: {
    queryDataByPage() {
      this.loading = true;

      var dataParam = {
        id: this.id,
        page: this.activeName
      }

      //其实是获取全局管理设置数据
      coreAdmin(this.token, dataParam).then(({data}) => {
        var dataParam = data.date;
        if (data.code == 200 && data.date != null) {
          switch (this.activeName) {
            case "1":
              this.LOGO = dataParam.logo;
              this.dataManagement = dataParam;

              this.data.dataManagement = JSON.parse(
                JSON.stringify(this.dataManagement)
              );
              break;
            case "2":
              this.ruleConfiguration = dataParam;

              this.Limit.dayLimit = this.ruleConfiguration.dayLimit == '∞' ? '不限制' : this.Limit.dayLimit;
              this.Limit.ticketLimit = this.ruleConfiguration.ticketLimit == '∞' ? '不限制' : this.Limit.ticketLimit;
              this.Limit.productLimit = this.ruleConfiguration.productLimit == '∞' ? '不限制' : this.Limit.productLimit;

              this.data.ruleConfiguration = JSON.parse(
                JSON.stringify(this.ruleConfiguration)
              );
              break;
            case "3":
              this.fundsConfiguration = dataParam;

              this.balanceNotification = dataParam.balanceNotification
              this.fundsConfiguration.balanceNotification = this.fundsConfiguration.balanceNotification.filter(item => item.notification == 1 || item.dashboardFund == 1);
              this.personalAccount = dataParam.personalAccount;

              if (dataParam.issueType == 1) {
                this.fundsConfiguration.personalAccount.push(dataParam.title)
              } else {
                dataParam.personalAccount.forEach(item => {
                  if (item.notification == 1)
                    this.fundsConfiguration.personalAccount.push(item)
                })
              }

              if (dataParam.brandDistrict == 0) {
                this.basicAccount = {
                  name: '南京维管信息科技有限公司',
                  account: '工行南京湖南路支行',
                  accountNum: '4301011009100323437'
                }
              } else {
                this.basicAccount = {
                  name: '上海橙籽维管信息技术有限公司',
                  account: '中国建设银行上海大连路支行',
                  accountNum: '31050175410000000956'
                }
              }

              this.data.fundsConfiguration = JSON.parse(
                JSON.stringify(this.fundsConfiguration)
              );
              break;

            case "4":
              this.processReview = dataParam;
              this.wechatNotification = dataParam.wechatNotification;
              this.regionManager = dataParam.regionManager;
              this.processReview.regionManager = dataParam.regionManager.filter(item => item.notification == 1);
              this.processReview.wechatNotification = dataParam.wechatNotification.filter(item => item.notification == 1);

              //备份数据,点击取消按钮时还原数据
              this.data.processReview = JSON.parse(
                JSON.stringify(this.processReview)
              );
              let a = JSON.parse(this.processReview.limitAudit)
              let b = JSON.parse(this.processReview.packageAudit)
              this.processReview.limitAudit = JSON.parse(JSON.stringify(a))
              this.processReview.packageAudit = JSON.parse(JSON.stringify(b))

              //解析发起重审和忽略小票有效期数据
              this.processReview.processAudit = JSON.parse(dataParam.processAudit);
              this.processReview.ignoreTicketAudit = JSON.parse(dataParam.ignoreTicketAudit);

              this.bindReAuditPerson()
              break;
          }
        }
      }).finally(() => {
        this.loading = false;
      });
    },

    notifyMsg(result, msg) {
      if (result) {
        this.$notify.success({
          title: "成功",
          message: msg,
          position: "bottom-right",
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: msg,
          position: "bottom-right",
        });
      }
    },
    changeTabs() {
      if (this.ZLisSet || this.YYisSet || this.JHisSet || this.YWisSet) {
        return this.$confirm('当前正在编辑的内容尚未保存，是否要取消修改？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (this.ZLisSet) {
            this.ZLisSet = false
            this.dataManagement = JSON.parse(
              JSON.stringify(this.data.dataManagement)
            );
          } else if (this.YYisSet) {
            this.YYisSet = false
            this.ruleConfiguration = JSON.parse(
              JSON.stringify(this.data.ruleConfiguration)
            );
          } else if (this.JHisSet) {
            this.JHisSet = false
            this.fundsConfiguration = JSON.parse(
              JSON.stringify(this.data.fundsConfiguration)
            );
          } else if (this.YWisSet) {
            this.YWisSet = false
            this.processReview = JSON.parse(
              JSON.stringify(this.data.processReview)
            );
          }
        })
      }
    },
    editInfo() {
      if (this.activeName == 1) {
        this.jc = ''
        this.ZLisSet = true;
      } else if (this.activeName == 2) {
        this.YYisSet = true
      } else if (this.activeName == 3) {
        this.JHisSet = true
      } else if (this.activeName == 4) {
        this.YWisSet = true
        this.$refs.ruleForm1.clearValidate()
        this.$refs.ruleForm2.clearValidate()
        this.$refs.processAuditForm.clearValidate()
        this.$refs.ignoreTicketForm.clearValidate()
      }
    },
    //上传LOGO
    uploadSectionFile(file) {
      this.loading = true
      const typeArr = ['image/png', 'image/bmp', 'image/svg', 'image/jpg', 'image/webp', 'image/jpeg'];
      const isJPG = typeArr.indexOf(file.raw.type) !== -1;
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error('上传图片格式有误');
        this.$refs.upload.clearFiles();
        this.photoInfo.files = null;
        return;
      }
      if (!isLt3M) {
        this.$message.error('上传图片大小不能超过 3MB');
        this.$refs.upload.clearFiles();
        this.photoInfo.files = null;
        return;
      }
      this.photoInfo.files = file.raw;
      // FormData 对象lo
      var formData = new FormData();
      // 文件对象
      formData.append('file', this.photoInfo.files);
      uploadLogo(this.token, formData, this.id).then(res => {
        if (res.data.code == 200) {
          this.LOGO = res.data.date
          this.notifyMsg(true, res.data.msg);

        } else {
          this.notifyMsg(false, res.data.msg);
        }
        this.loading = false
      })
    },
    //选择业务主要覆盖省份
    changeCoverageArea() {
      for (var item of this.dataManagement.coverageArea) {
        if (item.value == 1) {
          this.dataManagement.coverageArea = []
          this.dataManagement.coverageArea.push({label: '全国', value: '1'});
          this.disableProvinces = true
        }
      }
      if (this.dataManagement.coverageArea.length == 0) {
        this.disableProvinces = false
      }
    },
    //销量申报预警线下拉框方法
    changeLimit() {
      this.ruleConfiguration.dayLimit = this.Limit.dayLimit == '不限制' ? '∞' : this.ruleConfiguration.dayLimit == '∞' ? 3000 : this.ruleConfiguration.dayLimit;
      this.ruleConfiguration.ticketLimit = this.Limit.ticketLimit == '不限制' ? '∞' : this.ruleConfiguration.ticketLimit == '∞' ? 3000 : this.ruleConfiguration.ticketLimit;
      this.ruleConfiguration.productLimit = this.Limit.productLimit == '不限制' ? '∞' : this.ruleConfiguration.productLimit == '∞' ? 3000 : this.ruleConfiguration.productLimit;
    },
    confirmChange() {
      switch (this.activeName) {
        case '1':
          if (this.dataManagement.companyName == "")
            return this.notifyMsg(false, '请填写公司名称');

          if (this.dataManagement.companyInfo == "")
            return this.notifyMsg(false, '请填写公司简介');

          if (this.dataManagement.companyAddress == "")
            return this.notifyMsg(false, '请填写公司地址');

          if (this.dataManagement.coverageArea.length == 0)
            return this.notifyMsg(false, '请选择至少一条主要业务覆盖的省份');

          this.loading = true;

          setDataManager(this.token, this.dataManagement, this.id)
            .then((r) => {
              let {data} = r;
              if (data.code == 200) {
                this.jc = '\xa0\xa0'
                this.notifyMsg(true, data.msg);
                this.data.dataManagement = JSON.parse(JSON.stringify(this.dataManagement))
              } else if (data.code == 1) {
                this.notifyMsg(false, data.msg);
              }
            }).catch((error) => {
            let status = error.response.status;
            if (status == 500) {
              this.notifyMsg(false, '保存失败，请联系管理员');
            }
          }).finally(() => {
            this.loading = false;
            this.ZLisSet = !this.ZLisSet;
          });
          break;
        case '2':
          this.ruleConfiguration.dayLimit = this.ruleConfiguration.dayLimit != '' ? (this.ruleConfiguration.dayLimit != '∞' ? parseInt(this.ruleConfiguration.dayLimit) : this.ruleConfiguration.dayLimit) : 0;
          this.ruleConfiguration.ticketLimit = this.ruleConfiguration.ticketLimit != '' ? (this.ruleConfiguration.ticketLimit != '∞' ? parseInt(this.ruleConfiguration.ticketLimit) : this.ruleConfiguration.ticketLimit) : 0;
          this.ruleConfiguration.productLimit = this.ruleConfiguration.productLimit != '' ? (this.ruleConfiguration.productLimit != '∞' ? parseInt(this.ruleConfiguration.productLimit) : this.ruleConfiguration.productLimit) : 0;
          if (this.ruleConfiguration.dayLimit === '' && this.ruleConfiguration.productLimit === '' && this.ruleConfiguration.productLimit === '') {
            return this.notifyMsg(false, '请至少填写一条预警线信息');
          } else if (this.ruleConfiguration.dayLimit < this.ruleConfiguration.ticketLimit | this.ruleConfiguration.ticketLimit < this.ruleConfiguration.productLimit) {
            return this.notifyMsg(false, '每品预警线不得大于每单预警线并且每单预警线不得大于每日预警线');
          }
          if (this.ruleConfiguration.settleEffective == "") {
            return this.notifyMsg(false, '请填写小票申报失效申报信息');
          }
          if (this.ruleConfiguration.ticketEffective == "") {
            return this.notifyMsg(false, '请填写红利补发追溯期限信息');
          }

          this.loading = true;
          setRuleConfiguration(this.token, this.ruleConfiguration, this.id)
            .then((r) => {
              let {data} = r;
              if (data.code == 200)
                this.notifyMsg(true, data.msg);
              this.data.ruleConfiguration = JSON.parse(JSON.stringify(this.ruleConfiguration))
              if (data.code == 1)
                this.notifyMsg(false, data.msg);
            })
            .catch((error) => {
              let status = error.response.status;
              if (status == 500)
                this.notifyMsg(false, '审核失败，请联系管理员');
            })
            .finally(() => {
              this.loading = false;
              this.YYisSet = !this.YYisSet
            });
          break;
        case '3':
          if (this.fundsConfiguration.issueType == "")
            return this.notifyMsg(false, '请选择充值方式');

          if (this.fundsConfiguration.personalAccount.length == 0)
            return this.notifyMsg(false, '请填写打款账户户名');

          if (this.fundsConfiguration.method == "")
            return this.notifyMsg(false, '请选择服务费扣款方式');

          if (this.fundsConfiguration.issueType == '1')
            this.fundsConfiguration.personalAccount = []

          var newList = [];
          for (var item of this.fundsConfiguration.personalAccount) {
            if (typeof item == 'string') {
              newList.push({name: item, notification: 0, phoneNumber: null})
            } else {
              newList.push(item);
            }
          }
          this.fundsConfiguration.personalAccount = newList;

          this.loading = true;
          setFundsConfiguration(this.token, this.fundsConfiguration, this.id)
            .then((r) => {
              let {data} = r;
              if (data.code == 200)
                this.notifyMsg(true, data.msg);
              this.data.fundsConfiguration = JSON.parse(JSON.stringify(this.fundsConfiguration))
              if (data.code == 1)
                this.notifyMsg(false, data.msg);
            }).finally(() => {
            this.JHisSet = !this.JHisSet
            this.loading = false;
            localStorage.setItem('activteName', this.activeName)
            this.reload()
          });
          break;
        case '4':
          if (this.processReview.signMode == "") {
            return this.notifyMsg(false, '请选择导购签约审核信息');
          }
          if (this.processReview.packageAudit == "") {
            return this.notifyMsg(false, '请选择提成规则设置权限信息');
          }
          if (this.processReview.limitAudit == "") {
            return this.notifyMsg(false, '请选择销量申报设置权限信息');
          }
          if (this.processReview.limitAudit.reAudit === 1 && this.processReview.limitAudit.reAuditPerson.length === 0) {
            this.notifyMsg(false, '请选择复核人');
            this.$refs.ruleForm2.validate()
            return
          }
          if (this.processReview.packageAudit.reAudit === 1 && this.processReview.packageAudit.reAuditPerson.length === 0) {
            this.$refs.ruleForm1.validate()
            this.notifyMsg(false, '请选择复核人');
            return
          }

          //查看发起复核是否填写完整
          if (this.processReview.processAudit.reAudit && this.processReview.processAudit.reAuditPerson.length === 0) {
            this.$refs.processAuditForm.validate()
            return this.notifyMsg(false, '请选择复核人');
          }

          //过期小票复核是否填写完整
          if (this.processReview.ignoreTicketAudit.reAudit && this.processReview.ignoreTicketAudit.reAuditPerson.length === 0) {
            this.$refs.ignoreTicketForm.validate()
            return this.notifyMsg(false, '请选择复核人');
          }

          if (this.processReview.regionManager.length === 0) {
            this.$refs.ruleForm.validate();
            return this.notifyMsg(false, '请先设置区域管理员');
          }
          // if ((this.processReview.packageAudit.reAuditPerson.indexOf(1) !== -1 || this.processReview.limitAudit.reAuditPerson.indexOf(1) !== -1) && this.processReview.accountManagerCount === 0) {
          //   return this.notifyMsg(false, '请先设置区域管理员');
          // }
          if (this.processReview.wechatNotification.length === 0) {
            this.$refs.ruleForm.validate()
            this.notifyMsg(false, '请先设置总部管理员');
            return
          }
          this.field1 = []
          this.field2 = []
          this.loading = true;
          this.processReview.limitAudit.reAuditPerson.sort()
          this.processReview.packageAudit.reAuditPerson.sort()
          this.processReview.limitAudit = JSON.stringify(this.processReview.limitAudit)
          this.processReview.packageAudit = JSON.stringify(this.processReview.packageAudit)
          this.processReview.processAudit = JSON.stringify(this.processReview.processAudit)
          this.processReview.ignoreTicketAudit = JSON.stringify(this.processReview.ignoreTicketAudit)
          setProcessReview(this.token, this.processReview, this.id).then(res => {
            console.log(res)
            this.$refs.ruleForm.clearValidate()
            this.$refs.ruleForm1.clearValidate()
            this.$refs.ruleForm2.clearValidate()
            this.data.processReview = JSON.parse(JSON.stringify(this.processReview))
            let a = JSON.parse(this.processReview.limitAudit)
            let b = JSON.parse(this.processReview.packageAudit)
            this.processReview.limitAudit = JSON.parse(JSON.stringify(a))
            this.processReview.packageAudit = JSON.parse(JSON.stringify(b))
            this.processReview.processAudit = JSON.parse(JSON.stringify(JSON.parse(this.processReview.processAudit)))
            this.processReview.ignoreTicketAudit = JSON.parse(JSON.stringify(JSON.parse(this.processReview.ignoreTicketAudit)))
            this.bindReAuditPerson()
          }).finally(() => {
            this.loading = false
            this.YWisSet = !this.YWisSet

          })
          break;
      }
    },
    cancelChange() {
      if (this.activeName == 1 || this.activeName == 2 || this.activeName == 3 || this.activeName == 4) {
        this.$confirm("当前正在编辑的内容尚未保存，是否要取消修改？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          'modal-append-to-body': false,
          type: "warning",
        }).then(() => {
          this.$message({
            type: "success",
            message: "已取消修改",
          });
          if (this.activeName == 1) {
            this.dataManagement = JSON.parse(
              JSON.stringify(this.data.dataManagement)
            );
            this.ZLisSet = !this.ZLisSet;
            this.jc = '\xa0\xa0'
          } else if (this.activeName == 2) {
            this.ruleConfiguration = JSON.parse(
              JSON.stringify(this.data.ruleConfiguration)
            );

            this.Limit.dayLimit = this.ruleConfiguration.dayLimit == '∞' ? '不限制' : '按数量';
            this.Limit.ticketLimit = this.ruleConfiguration.ticketLimit == '∞' ? '不限制' : '按数量';
            this.Limit.productLimit = this.ruleConfiguration.productLimit == '∞' ? '不限制' : '按数量';

            this.YYisSet = !this.YYisSet;
          } else if (this.activeName == 3) {
            this.fundsConfiguration = JSON.parse(
              JSON.stringify(this.data.fundsConfiguration)
            );
            this.JHisSet = !this.JHisSet;
          } else if (this.activeName == 4) {
            this.processReview = JSON.parse(
              JSON.stringify(this.data.processReview)
            );
            this.$refs.ruleForm.clearValidate()
            this.$refs.ruleForm1.clearValidate()
            this.$refs.ruleForm2.clearValidate()
            this.field1 = []
            this.field2 = []
            let a = JSON.parse(this.data.processReview.limitAudit)
            let b = JSON.parse(this.data.processReview.packageAudit)
            this.processReview.limitAudit = JSON.parse(JSON.stringify(a))
            this.processReview.packageAudit = JSON.parse(JSON.stringify(b))

            this.processReview.processAudit = JSON.parse(this.data.processReview.processAudit)
            this.processReview.ignoreTicketAudit = JSON.parse(this.data.processReview.ignoreTicketAudit)

            this.bindReAuditPerson()
            this.YWisSet = !this.YWisSet;
          }
        });
      }
    },
    changeIssueType() {
      if (this.fundsConfiguration.issueType == '1') {
        this.fundsConfiguration.personalAccount = [this.fundsConfiguration.title]
      } else {
        this.fundsConfiguration.personalAccount = this.personalAccount
      }
    },
    //点击复制基础钱包充值方式
    handlePaste1() {
      this.$copyText('开户行: ' + this.basicAccount.account + '  公司: ' + this.basicAccount.name + '  银行卡号: ' + this.basicAccount.accountNum).then(() => {
        this.$message.success({message: '复制成功'})
      }).catch(() => {
        this.$message.error({message: '复制失败'})
      })
    },
    //点击复制服务费钱包充值方式
    handlePaste2() {
      this.$copyText('开户行: 中国建设银行上海大连路支行  公司: 上海橙籽维管信息技术有限公司  银行卡号: 31050175410000000956').then(() => {
        this.$message.success({message: '复制成功'})
      }).catch(() => {
        this.$message.error({message: '复制失败'})
      })
    },
    //导出单品预警线系数excel文件
    reportExcel() {
      this.loading1 = true
      reportExcel(this.token, localStorage.getItem("supplierId")).then(res => {
        if (res !== null) {
          this.$notify({
            type: 'success',
            message: '导出成功',
            title: '成功',
            position: 'bottom-right'
          })
          this.handleDownload(res)
        }
      }).catch(error => {
        this.$notify({
          title: '错误',
          message: '导出错误，请及时联系管理员',
          type: 'error',
          position: 'bottom-right'
        })
      }).finally(() => {
        this.loading1 = false
      })
    },
    putExcel() {
      this.$refs.uploadLabel.click()
    },
    //上传单品预警线系数excel文件
    extraExcel() {
      this.loading2 = true
      let inputDOM = this.$refs.uploadLabel
      let file = inputDOM.files[0]
      let formData = new FormData();
      formData.append("file", file)
      putExcel(this.token, localStorage.getItem("supplierId"), formData).then(res => {
        if (res.data.code == 200) {
          this.$notify.success({
            title: '成功',
            message: res.data.msg,
            position: 'bottom-right'
          })
        }
        if (res.data.code == 1)
          this.$notify.error({
            title: '错误',
            message: res.data.msg,
            position: 'bottom-right'
          })
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '修改失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading2 = false
        this.$refs.uploadLabel.value = ''
      })
    },
    handleDownload(res) {
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    defaultData() {
      if (this.ruleConfiguration.dayLimit == '')
        this.ruleConfiguration.dayLimit = 0;
      if (this.ruleConfiguration.ticketLimit == '')
        this.ruleConfiguration.ticketLimit = 0;
      if (this.ruleConfiguration.productLimit == '')
        this.ruleConfiguration.productLimit = 0;
      console.log(this.ruleConfiguration.dayLimit)
      console.log(this.ruleConfiguration.ticketLimit)
      console.log(this.ruleConfiguration.productLimit)
    },
    selectAllIdentity(type) {
      switch (type) {
        case 1:
          if (this.selectAllOption1) {
            this.field1 = this.identityField1
          } else {
            this.field1 = []
            this.processReview.limitAudit.reAuditPerson = []
          }
          if (this.field1.length != 0) {
            this.field1.forEach((item, index) => {
              if (item === '区域管理员') {
                this.processReview.limitAudit.reAuditPerson.push(1)
              }
              if (item === '总部管理员') {
                this.processReview.limitAudit.reAuditPerson.push(2)
              }
            })
          } else if (this.field1.length == 1) {
            this.processReview.limitAudit.reAuditPerson = []
            this.field1.forEach((item, index) => {
              if (item === '区域管理员') {
                this.processReview.limitAudit.reAuditPerson.push(1)
              }
              if (item === '总部管理员') {
                this.processReview.limitAudit.reAuditPerson.push(2)
              }
            })
          }
          break;
        case 2:
          if (this.selectAllOption2) {
            this.field2 = this.identityField2
          } else {
            this.field2 = []
            this.processReview.packageAudit.reAuditPerson = []
          }
          if (this.field2.length != 0) {
            this.field2.forEach((item, index) => {
              if (item === '区域管理员') {
                this.processReview.packageAudit.reAuditPerson.push(1)
              }
              if (item === '总部管理员') {
                this.processReview.packageAudit.reAuditPerson.push(2)
              }
            })
          } else if (this.field2.length == 1) {
            this.processReview.packageAudit.reAuditPerson = []
            this.field2.forEach((item, index) => {
              if (item === '区域管理员') {
                this.processReview.packageAudit.reAuditPerson.push(1)
              }
              if (item === '总部管理员') {
                this.processReview.packageAudit.reAuditPerson.push(2)
              }
            })
          }
          break;
      }
    },
    judgementField1() {
      //判断全选框状态
      this.selectAllOption1 = this.field1.length === 2
      //绑定变量与数据
      if (this.processReview.limitAudit.reAudit === 0) {
        this.field1 = []
        this.processReview.limitAudit.reAuditPerson = []
      } else {
        this.processReview.limitAudit.reAuditPerson = []
        this.field1.forEach(x => {
          if (x === '区域管理员') {
            this.processReview.limitAudit.reAuditPerson.push(1)
          } else {
            this.processReview.limitAudit.reAuditPerson.push(2)

          }
        })
      }
    },
    judgementField2() {
      //判断全选框状态
      this.selectAllOption2 = this.field2.length === 2
      //绑定变量与数据
      if (this.processReview.packageAudit.reAudit === 0) {
        this.field2 = []
        this.processReview.packageAudit.reAuditPerson = []
      } else {
        this.processReview.packageAudit.reAuditPerson = []
        this.field2.forEach(x => {
          if (x === '区域管理员') {
            this.processReview.packageAudit.reAuditPerson.push(1)
          } else {
            this.processReview.packageAudit.reAuditPerson.push(2)

          }
        })
      }
    },
    //选中直接生效,清空复核人列表数据
    changeAuditType(item) {
      //调整为直接生效
      if (!item.reAudit) {
        item.reAuditPerson = [];
      }
    },

    //绑定数据
    bindReAuditPerson() {
      if (this.processReview.limitAudit.reAuditPerson.length != 0) {
        this.field1 = []
        this.processReview.limitAudit.reAuditPerson.forEach(item => {
          if (item == 1) {
            this.$nextTick(() => {
              this.field1.push('区域管理员')
            })
          }
          if (item == 2) {
            this.$nextTick(() => {
              this.field1.push('总部管理员')
            })
          }
        })
        if (this.processReview.limitAudit.reAuditPerson.length == 2) {
          this.selectAllOption1 = true
        }
      }
      if (this.processReview.packageAudit.reAuditPerson.length != 0) {
        this.field2 = []
        this.processReview.packageAudit.reAuditPerson.forEach(item => {
          if (item == 1) {
            this.$nextTick(() => {
              this.field2.push('区域管理员')
            })
          }
          if (item == 2) {
            this.$nextTick(() => {
              this.field2.push('总部管理员')
            })
          }
        })
        if (this.processReview.packageAudit.reAuditPerson.length == 2) {
          this.selectAllOption2 = true
        }
      }
    }
  },
  beforeRouteLeave: function (to, from, next) {
    if (this.ZLisSet || this.YYisSet || this.JHisSet || this.YWisSet) {
      MessageBox.confirm('当前正在编辑的内容尚未保存，是否要取消修改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        next()
      }).catch(() => {
        next(false)
      })
    } else {
      next()
    }
  }
}
</script>

<style scoped>

.ov-inline {
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
}

.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.el-form >>> .el-form-item .el-form-item__label {
  white-space: pre-line;
  line-height: 16px;
  text-align: right;
  padding-right: 20px;
  margin-top: 10px;
  color: #919399;
}

.el-alert {
  padding: 0px;
  margin: 0px 0px 0px -5px;
}

.el-textarea >>> .el-textarea__inner {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
  "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

/*>>> .el-input__prefix {*/
/*  left: 10px;*/
/*  margin-top: 12px;*/
/*}*/

.yy >>> .el-input-group__prepend {
  border-right: 0px;
  border-radius: 0px;
}

.el-alert--info.is-light {
  background-color: #ffffff;
  color: #909399;
}

.cw .el-input.is-disabled >>> .el-input__inner {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  cursor: text;
}

>>> .el-select .el-input__inner {
  border-radius: 0px 0px 0px 0px;
}

>>> .el-input--prefix .el-input__inner {
  border-radius: 0px 1px 1px 0px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0
}

.title-line {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  flex-direction: row;
  margin-bottom: 20px;
}

.title {
  font-weight: 600;
  font-size: 16px;
  letter-spacing: -0.045em;
  color: #979797;
}

.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
  color: #C0C4CC;
  cursor: not-allowed;
  background-image: none;
  background-color: #D8D8D8 !important;
  border-color: #EBEEF5;
}
</style>
<style>
.myForm1 .el-form-item__error {
  display: none;
}
</style>
